import type { StarterDataTransferObject } from '@mobi/api-types/racePage/types'
import type { IObservableStarter } from '../Model/Observables/IObservableStarter'
import ObservableTrotStarter from '../Model/Observables/ObservableTrotStarter'
import { BaseRaceCodeBuilder } from './BaseRaceCodeBuilder'

export default class TrotBuilder extends BaseRaceCodeBuilder {
  build(dto: StarterDataTransferObject): IObservableStarter {
    const model = super.addBaseInformation(
      new ObservableTrotStarter(),
      dto
    ) as ObservableTrotStarter
    model.template('trot-starters-template')
    model.tag('Trot')
    model.handicap(dto.Handicap)
    return model
  }
}
